import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';

import { getShopify, isAppBridgeAvailable } from './lib/app-bridge';
import { queryClient } from './lib/query-client';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';

function App() {
  // Check if App Bridge is available when the app loads
  useEffect(() => {
    if (isAppBridgeAvailable()) {
      const shopify = getShopify();
      console.log('✅ App Bridge available:', shopify);
    } else {
      console.warn('⚠️ App Bridge not available (this is normal if running outside Shopify admin)');
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider
      i18n={{
        Polaris: {
          Avatar: {
            label: 'Avatar',
            labelWithInitials: 'Avatar with initials {initials}',
          },
          ContextualSaveBar: {
            save: 'Save',
            discard: 'Discard',
          },
          TextField: {
            characterCount: '{count} characters',
          },
          TopBar: {
            toggleMenuLabel: 'Toggle menu',

            SearchField: {
              clearButtonLabel: 'Clear',
              search: 'Search',
            },
          },
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </BrowserRouter>
      </AppProvider>
    </QueryClientProvider>
  );
}

export default App;

